import React from "react";
import { ComingSoonPage } from "../currentAffairs/CurrentAffairs";

const StateGk = () => (
  <ComingSoonPage
    screenName="State GK"
    subtitle={
      "Prepare for your state exams with dedicated State GK content including:"
    }
  />
);

export default StateGk;
